module.exports = __webpack_public_path__ + "img/photo-22.4ca51694.jpg";